export enum FollowUpStudyReportStatus {
	PendingStudyEmployeeApproval = 1,
	ApprovedByStudyEmployee = 2,
}
